import { useConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem";
import { OrderTypes } from "@shared/types";
import useSharedSelectItem from "@shared/features/tradingTerminal/common/hooks/useSharedSelectItem";

interface useSelectItemProps {
  item: any;
  orderType?: OrderTypes;
  disabled?: boolean;
}

const useSelectItem = ({ item, orderType, disabled }: useSelectItemProps) => {
  const {
    itemValue,
    handleItemChange,
    itemName,
    itemOptions,
    prefix,
    suffix,
    itemChildren,
    itemShouldDisplay,
  } = useConfigurationItem({
    item,
    valueParser: undefined,
  });

  const {
    options,
    isSelectOpen,
    onSelectClick,
    isStrategyItem,
    isNewCustomStrategy,
    strategyModalProps,
    tooltipProps,
    onSaveClick,
    onCustomStrategiesClick,
  } = useSharedSelectItem({
    orderType,
    disabled,
    itemValue,
    handleItemChange,
    itemName,
    itemOptions,
    itemChildren,
    itemShouldDisplay,
  });

  return {
    itemName,
    options,
    isSelectOpen,
    onSelectClick,
    itemValue,
    handleItemChange,
    prefix,
    suffix,
    isStrategyItem,
    isNewCustomStrategy,
    strategyModalProps,
    itemShouldDisplay,
    tooltipProps,
    onSaveClick,
    onCustomStrategiesClick,
  };
};

export default useSelectItem;
